import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  previewSection: {
    display: 'grid',
    gap: theme.spacing(2),
  },
}));
